var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolarpanelTransparency(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 108.685,
    height: 108.694,
    viewBox: "0 0 108.685 108.694",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_444",
    "data-name": "Trac\\xE9 444",
    d: "M94.6-51.334V-45.9H90.972v-5.435Zm12.277-6.59,3.843,3.843-2.562,2.562-3.843-3.843Zm-28.18,0,2.562,2.562-3.843,3.843-2.562-2.562ZM92.784-83.942A14.493,14.493,0,0,1,107.276-69.45,14.493,14.493,0,0,1,92.784-54.957,14.509,14.509,0,0,1,78.291-69.45,14.493,14.493,0,0,1,92.784-83.942Zm0,3.623A10.88,10.88,0,0,0,81.914-69.45,10.869,10.869,0,0,0,92.784-58.58,10.869,10.869,0,0,0,103.653-69.45,10.869,10.869,0,0,0,92.784-80.319ZM74.668-71.261v3.623H69.233v-3.623Zm41.666,0v3.623H110.9v-3.623ZM77.41-87.383l3.843,3.843-2.562,2.562-3.843-3.843Zm30.745,0,2.562,2.562-3.843,3.843-2.562-2.562ZM94.6-93v5.435H90.972V-93Z",
    transform: "translate(-69.233 93)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_443",
    "data-name": "Trac\\xE9 443",
    d: "M-937,3450.308H1114.361V-2067H-937Z",
    transform: "translate(937 2067)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_447",
    "data-name": "Trac\\xE9 447",
    d: "M123.6,5.456,80.12-74.253a1.812,1.812,0,0,0-1.591-.944H27.806a1.886,1.886,0,0,0-.4.053h-.043a1.754,1.754,0,0,0-.5.221,1.368,1.368,0,0,0-.13.1,1.9,1.9,0,0,0-.391.4c-.025.038-.06.069-.083.109a1.576,1.576,0,0,0-.1.228,1.472,1.472,0,0,0-.063.145A1.81,1.81,0,0,0,26-73.4v12.7a1.817,1.817,0,0,0,.217.862L62.443,7.186a1.813,1.813,0,0,0,1.594.949h57.97A1.812,1.812,0,0,0,123.6,5.456ZM108.085-15.415H95.91l-8.893-16.3H99.192ZM64.608-35.342H50.62l-8.893-16.3H55.715Zm-4.764-16.3H72.019l8.893,16.3H68.736Zm6.741,19.927,8.893,16.3H61.49L52.6-31.719Zm4.129,0H82.888l8.893,16.3H79.605Zm26.5-3.623H85.04l-8.893-16.3H88.323ZM77.453-71.574l8.893,16.3H74.171l-8.893-16.3Zm-16.3,0,8.893,16.3H57.867l-8.893-16.3Zm-16.3,0,8.893,16.3H39.751l-8.893-16.3ZM65.124,4.512,29.617-61.162V-66.28L68.231,4.512Zm7.235,0-8.893-16.3H77.453l8.893,16.3Zm18.116,0-8.893-16.3H93.757l8.893,16.3Zm16.3,0-8.893-16.3h12.175l8.893,16.3Z",
    transform: "translate(-26.003 75.197)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1826",
    "data-name": "Groupe 1826",
    opacity: 0.303
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1764",
    "data-name": "Groupe 1764",
    transform: "translate(61.584 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1763",
    "data-name": "Groupe 1763",
    transform: "translate(-1433.437 -2812.075)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_442",
    "data-name": "Trac\\xE9 442",
    d: "M68.233-94h49.95v49.95H68.233Z",
    transform: "translate(1363.779 2904.65)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1766",
    "data-name": "Groupe 1766",
    transform: "translate(0 25.362)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1765",
    "data-name": "Groupe 1765",
    transform: "translate(-1371.853 -2837.437)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_445",
    "data-name": "Trac\\xE9 445",
    d: "M25-76.2H125.668V9.984H25Z",
    transform: "translate(1345.425 2912.209)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarpanelTransparency);
export default __webpack_public_path__ + "static/media/solarpanel-transparency.2d8c3cc691acd5a86d4ae08f76d72973.svg";
export { ForwardRef as ReactComponent };